__turbopack_context__.v({
  "axis": "progress-visual-module__PcMD1W__axis",
  "bar": "progress-visual-module__PcMD1W__bar",
  "counter": "progress-visual-module__PcMD1W__counter",
  "labels": "progress-visual-module__PcMD1W__labels",
  "monthLabel": "progress-visual-module__PcMD1W__monthLabel",
  "pct": "progress-visual-module__PcMD1W__pct",
  "plot": "progress-visual-module__PcMD1W__plot",
  "root": "progress-visual-module__PcMD1W__root",
});
